import React, { useState } from 'react';
import { Button } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import DialogMapModal from '@shared/components/Dialogs/Map';
import MapContainer from '@shared/components/MapContainer';
import { sxStyle } from './styles';

const BookingMapButton = ({ hotelDetails }) => {
  const [showModalMap, setShowModalMap] = useState(false);

  if (!hotelDetails.location.latitude) return null;

  return (
    <>
      <Button
        sx={sxStyle.buttonWithIcons}
        onClick={() => setShowModalMap(true)}
        startIcon={<RoomIcon />}
      >
        Ver en mapa
      </Button>
      <DialogMapModal
        isOpen={showModalMap}
        onClose={() => setShowModalMap(false)}
        title={hotelDetails.name}
      >
        {showModalMap && (
          <MapContainer
            center={{
              lat: hotelDetails.location.latitude,
              lng: hotelDetails.location.longitude,
            }}
          />
        )}
      </DialogMapModal>
    </>
  );
};

export default BookingMapButton;
